import classNames from 'classnames/bind';
import { FC } from 'react';
import { SOLUTION } from '../../../constants/solution/solution.constant';
import { IGetJDViewSettingResponse } from '../../../interface/position/getJDViewSetting';
import { IJD } from '../../../interface/recruit/IJD';
import { SOLUTION_TYPE } from '../../../util/solution';
import style from './JDProcess.module.scss';
import JDProcessIconButtons from './JDProcessIconButtons';
import JDProcessItems from './JDProcessItems';
import JDProcessJobflexButtons from './JDProcessJobflexButtons';
import JDProcessSubmitButton from './JDProcessSubmitButton';
const cx = classNames.bind(style);

interface IProps {
  id: number;
  handleClickApply?: () => void;
  data: IJD;
  viewSettingData: IGetJDViewSettingResponse;
  readOnly?: boolean;
}

const JDProcess: FC<IProps> = ({ data, viewSettingData, handleClickApply, readOnly = false }) => {
  const {
    startDateTime = '',
    endDateTime = '',
    submissionStatus,
    progressStatus,
    resumeUpdateUrl,
    myPageUrl,

    // [JF] 비공개 공고만
    writeButtonStatus,
  } = data;

  return (
    <div className={cx('wrapper')}>
      <JDProcessItems viewSettingData={viewSettingData} data={data} />
      <div className={cx('button-wrapper')}>
        <JDProcessSubmitButton
          writeButtonStatus={writeButtonStatus}
          submissionStatus={submissionStatus}
          progressStatus={progressStatus}
          startDateTime={startDateTime}
          endDateTime={endDateTime}
          handleClickApply={handleClickApply}
        />
        <JDProcessJobflexButtons
          show={SOLUTION_TYPE === SOLUTION.JOBFLEX}
          readonly={readOnly}
          writeButtonStatus={writeButtonStatus}
          progressStatus={progressStatus}
          resumeUpdateUrl={resumeUpdateUrl ?? ''}
          myPageUrl={myPageUrl ?? ''}
        />
        <JDProcessIconButtons readonly={readOnly} />
      </div>
    </div>
  );
};

export default JDProcess;
